export enum AmlBotApplicantType {
  PERSON = 'PERSON',
  COMPANY = 'COMPANY'
}
